import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

type PersonsState = {
  personIdDisplayedInDrawer: string | null;
};
const initialState: PersonsState = {
  personIdDisplayedInDrawer: null,
};

export const personsSlice = createSlice({
  name: 'persons',
  initialState,
  reducers: {
    setPersonIdDisplayedInDrawer: (state, { payload }: PayloadAction<string | null>) => {
      state.personIdDisplayedInDrawer = payload;
    },
  },
  selectors: {
    personIdDisplayedInDrawer: (state) => state.personIdDisplayedInDrawer,
  },
});

export const { personIdDisplayedInDrawer } = personsSlice.selectors;
export const { setPersonIdDisplayedInDrawer } = personsSlice.actions;
